/// <reference path="../../../WebUI/typings/tsd.d.ts" />

import * as Rest from "../Generated/RestClient";
import { clientAppSettings } from "../Models/ClientAppSettings";
import { Environment } from "./Environment";

export function botDirectoryLink(bot: Rest.IBot) {
    return '/';
}

export function botEditLink(bot: Rest.IBot) {
    return `/bots/edit?id=${encodeURIComponent(bot.Id)}`;
}

export function botViewLink(bot: Rest.IBot) {
    return `/bots?id=${encodeURIComponent(bot.Id)}`;
}

/**
 * Get the link to a bot service in Azure Ibiza portal.
 */
export function getAzureIbizaBotUrl(subscriptionId: string, resourceGroupName: string, botId: string): string {
    let url = Environment.azurePortalUrl() + "?";
    const envQSParams = getAzureIbizaBotEnvironmentQSParameters();
    if (envQSParams) {
        url += envQSParams;
    }

    return `${url}#resource/subscriptions/${subscriptionId}/resourceGroups/${resourceGroupName}/providers/Microsoft.BotService/botServices/${botId}`;
}

/**
 * Get the environment specific part of the query string for the ABS Ibiza blade.
 */
function getAzureIbizaBotEnvironmentQSParameters(): string {
    const env = (clientAppSettings.environment).toLowerCase();
    switch (env)
    {
        case "scratch":
        case "ppe":
        case "usgovppe":
            return `Microsoft_Azure_BotService_env=${env}&feature.showassettypes=Microsoft_Azure_BotService_BotService&feature.canmodifystamps=true&Microsoft_Azure_BotService=friendName`;
        case "usgovprd":
        default:
            return "";
    }
}

/**
 * get the server relative url of window.location including query
 */
export function relativeUrl(location: Location): string {
    return `${location.pathname}${location.search}`;
}

export function getSignInUrl(): string {
    const path = relativeUrl(window.location);

    const paramValue = encodeURIComponent(path);
    return `/identity/signin?requestUrl=${paramValue}`;
}



// WEBPACK FOOTER //
// ./Client/Utils/Links.ts